/**
 * 答题-结算分享
 * auth：xuyan
 * time：2023-06-13 18:57
 */

import { LayoutDesktop } from '@/components/LayoutPC/LayoutDesktop';
import {
  useRecoilValue,
  useRecoilCallback,
  useSetRecoilState,
  useRecoilValueLoadable,
  useRecoilRefresher_UNSTABLE,
} from 'recoil';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import html2canvas from 'html2canvas';
import { fetchShareInfoState } from '@/models/shareState';
import { Toast } from 'antd-mobile';
import './index.scss';
import { ShareText, shareBgSrc } from '@/utils/setting';
import classnames from 'classnames';
import { fetchHonorsInfoState, honorsInfoState } from '@/models/honorsState';
import { HonorsInfoModel } from '@/models/typing';
import ErrorPage from '@/components/Error';
import { LoadingPage } from '@/components/Loading';
import { Tracking } from '@/utils/tracking';
import { SpinLoading } from 'antd-mobile';

// const sBgSrc = shareBgSrc();
// const sharetext = ShareText();
export const SharePage = ({ logId, queId }: { logId: string, queId: string }) => {
  const navigate = useNavigate();

  const info = useRecoilValue(honorsInfoState);

  let list = info.achieve_list.filter((item) => item.status == '1');

  const [selected, setSelected] = useState(-1); //选中的成就图id

  const [isPop, setPop] = useState(false);

  const [imgUrl, setImgUrl] = useState('');

  const [shareInfo, setShareInfo] = useState({
    achieve: {
      img: '',
    },
    info: {
      question_count: 20,
      correct_num: 0,
      correct_pre: 0,
      answer_time: '',
      error_count: 0,
    },
    questionnaire_title: '',
    questionnaire_remark: '',
  });

  const [sBgSrc, setSBgSrc] = useState(shareBgSrc());
  const [sharetext, setText] = useState(ShareText());

  const [isload, setLoad] = useState(false);


  const createImg = () => {
    setLoad(true);
    let ss = document.querySelector('#shareImage');
    getShareImageBase64(ss)
      .then((res: any) => {
        setImgUrl(res);
        setLoad(false);
      })
      .catch((error) => {
        console.log('%cindex.tsx line:69 error', 'color: #007acc;', error);
      });
  };

  const handleShare = useRecoilCallback(
    ({ snapshot }) =>
      async (selected) => {
        try {
          if (isload) return;
          const res: any = await snapshot.getPromise(
            fetchShareInfoState({
              achieve_id: String(selected),
              answer_log_id: logId ?? '',
              questionnaire_id: queId ?? '',
            })
          );
          setText(ShareText());
          setSBgSrc(shareBgSrc());
          setShareInfo(res);
          createImg();
        } catch (error) { }
      },
    []
  );

  const onShareClose = () => {
    setImgUrl('');
  };

  const getShareImageBase64 = (imgDoc: any) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        html2canvas(imgDoc, {
          useCORS: true,
          scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2,
          allowTaint: true,
          height: imgDoc.scrollHeight,
          windowHeight: imgDoc.scrollHeight,
        }).then((canvas: any) => {
          console.log('%cindex.tsx line:56 canvas', 'color: #007acc;', canvas);
          const imgData = canvas.toDataURL('image/jpeg', 1.0);
          resolve(imgData);
        });
      }, 300);
    });
  };

  // 选择成就图
  const handleSelect = (item: any) => {
    setSelected(Number(item.achieve_id));
  };

  return (
    <LayoutDesktop>
      <div className='honor-pc'>
        <img
          className='honor-pc-title'
          src={require('../../../assets/img/m-flaunt-title.png')}
          alt=''
        />
        <div
          className={classnames(
            'honor-pc-pics',
            list?.length < 4 && 'flex-pic'
          )}
        >
          {list?.map((item, index) => {
            return (
              <div
                className='honor-pc-pic'
                onClick={() => handleSelect(item)}
                key={index}
              >
                <div className='honor-pc-pic__box'>
                  <img src={item.img} alt='' />
                  <div
                    className={
                      selected === Number(item.achieve_id) ? 'selected' : ''
                    }
                  ></div>
                </div>
                <div className='honor-pc-pic__text'>{item.title}</div>
              </div>
            );
          })}
        </div>
        <div className='honor-pc-btns'>
          <div
            className='honor-pc-btn return-index'
            onClick={() => setPop(true)}
          ></div>
          <div
            className='honor-pc-btn return'
            onClick={() => {
              navigate(-1);
            }}
          ></div>
          <div
            className='honor-pc-btn share'
            onClick={() => {
              if (selected === -1) {
                return Toast.show({ content: '请选择成就图～' });
              } else {
                handleShare(selected);
              }
            }}
          ></div>
          {isPop && (
            <div className='pc-reward-back'>
              <div className='no' onClick={() => setPop(false)}></div>
              <div
                className='yes'
                onClick={() => {
                  navigate('/');
                }}
              ></div>
            </div>
          )}
        </div>
        {/* 海报html */}
        <div className='p-share-image'>
          <div
            className='m-share-pc share-canvas'
            style={{
              backgroundImage: `url(
                  ${sBgSrc}
                )`,
              backgroundSize: 'cover',
              backgroundPosition: 'top center',
            }}
            id='shareImage'
          >
            <img
              className='share-canvas-logo'
              src={require('../../../assets/img/icon-colg.png')}
              alt=''
            />
            <div className='m-share-pc-achievePic'>
              <img src={shareInfo.achieve?.img} alt='' />
              <div></div>
            </div>
            <div className='m-share-pc-text'>
              <div className='m-share-pc-text__title'>
                我参与了COLG答题王活动，并在
                {shareInfo?.questionnaire_title}
                {shareInfo?.questionnaire_remark &&
                  `（${shareInfo?.questionnaire_remark}）`}
                中取得了绝佳成绩
              </div>
              <div className='m-share-pc-text__result'>
                <span>
                  答题数:
                  <em className='highText'>
                    {shareInfo?.info?.question_count}
                  </em>
                </span>
                <span>
                  错题数:
                  <em className='highText'>{shareInfo?.info?.error_count}</em>
                </span>
                <span>
                  正确率:
                  <em className='highText'>{shareInfo?.info?.correct_pre}%</em>
                </span>
                <span className='alone'>
                  答题时长:
                  <em className='highText'>{shareInfo?.info?.answer_time}</em>
                </span>
              </div>
              <div className='m-share-pc-text__slogan'>{sharetext}</div>
            </div>

            <div className='share-canvas-qrcode'>
              扫码参与
              <br />
              答题王活动
              <img
                src='https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/code.png/ori_png'
                alt=''
              />
              <div className='share-canvas-qrcode-mask'></div>
            </div>
          </div>
          {(isload || imgUrl) && (
            <div className='p-share-pop' onClick={onShareClose}>
              {imgUrl && (
                <img className='shareCanvasImage' src={imgUrl} alt='' />
              )}
              {isload && (
                <div className='p-share-pop-loading'>
                  <SpinLoading />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </LayoutDesktop>
  );
};

export const DesktopShare = () => {
  const { logId, queId, id } = useParams();

  const setHonorsInfo = useSetRecoilState(honorsInfoState);

  const { state, contents } = useRecoilValueLoadable<HonorsInfoModel>(
    fetchHonorsInfoState(id ?? '')
  );

  const refresh = useRecoilRefresher_UNSTABLE(fetchHonorsInfoState(id ?? ''));

  useEffect(() => {
    if (state === 'hasValue') {
      setHonorsInfo(contents);
    }
  }, [state]);

  switch (state) {
    case 'hasValue':
      return <SharePage logId={logId ?? ''} queId={queId ?? ''} />;
    case 'hasError':
      return <ErrorPage message={contents.message} onRetry={() => { refresh(); }} />;
    case 'loading':
      return <LoadingPage />;
  }
};
